import Message from './models/Message'
import { SoundId } from 'sound/SoundPlayer'
import { Observable } from 'rxjs'
import { map, filter } from 'rxjs/operators'

/**
 * Observable for sounds to play on incomming messages.
 *
 * @param newMessage$
 */
export function MessageSounds(
  newMessage$: Observable<Message>,
): Observable<SoundId> {
  return newMessage$.pipe(
    filter((message) => message.sender.isCurrentUser === false),
    map(() => SoundId.GotMessage),
  )
}
